import { Button } from "antd";
import Button_0 from "./Button.js";
import AsyncButton from "./AsyncButton.js";
import DisableTooltipButton from "./DisableTooltipButton.js";
const ButtonWithSubComponents = Button_0;
ButtonWithSubComponents.Group = Button.Group;
ButtonWithSubComponents.AsyncButton = AsyncButton;
ButtonWithSubComponents.DisableTooltipButton = DisableTooltipButton;
const components_button = ButtonWithSubComponents;
export { components_button as default };
